module.exports = __webpack_public_path__ + "img/arrow.d1cbb115.svg";